import { Sprite } from "./core/Sprite"
import { TweenMax } from "gsap";

export class BlobAnimation {
  constructor(options) {
    this.options = options

    this.oldMousePoint = { x: 0, y: 0 }

    this.hidden = false

    this.hover = false

    this.initialize()
  }

  initialize() {
    this.canvas = this.options.canvas

    this.canvas.width = this.options.size.width

    this.canvas.height = this.options.size.height

    this.sprite = new Sprite()

    this.sprite.canvas = this.canvas

    this.sprite.padding = this.options.padding

    this.sprite.strength = this.options.strength

    this.sprite.position = this.options.position

    this.sprite.gradient = this.options.gradient

    this.sprite.numPoints = this.options.points.num

    this.sprite.init()

    this.sprite.render()

    //window.addEventListener('dblclick', this.toggle.bind(this));

    window.addEventListener("mousemove", this.move.bind(this))

    window.addEventListener("touchmove", this.move.bind(this))

    if (this.options.size.fluid) {
      window.addEventListener("resize", this.resize.bind(this))

      this.resize()
    }
  }

  toggle(event) {
    if (!this.hidden) {
      this.hidden = true

      this.sprite.hide()
    } else {
      this.hidden = false

      this.sprite.show()
    }
  }

  move(event) {
    let steps = 12

    let angle = null

    let center = this.sprite.center

    let radiusX = this.sprite.radius.x

    let radiusY = this.sprite.radius.y

    let strength = this.sprite.strength

    let rect = this.canvas.getBoundingClientRect()

    let pointerX = event.touches
      ? event.touches[0].clientX - rect.left
      : event.clientX - rect.left

    let pointerY = event.touches
      ? event.touches[0].clientY - rect.top
      : event.clientY - rect.top

    let diff = { x: pointerX - center.x, y: pointerY - center.y }

    let dist =
      (diff.x * diff.x) / (radiusX * radiusX) +
      (diff.y * diff.y) / (radiusY * radiusY)

    let q // calculate which ellipse quadrant the targetPt is in

    if (pointerX > center.x) {
      q = pointerY > center.y ? 0 : 3
    } else {
      q = pointerY > center.y ? 1 : 2
    }

    // calc beginning and ending radian angles to check
    let r1 = q * (Math.PI / 2)

    let r2 = (q + 1) * (Math.PI / 2)

    let dr = Math.PI / 2 / steps

    let minLengthSquared = 200000000

    let minX, minY

    // walk the ellipse quadrant and find a near-point
    for (let r = r1; r < r2; r += dr) {
      // get a point on the ellipse at radian angle == r
      let ellipseX = center.x + radiusX * Math.cos(r)

      let ellipseY = center.y + radiusY * Math.sin(r)

      // calc distance from ellipsePt to targetPt
      let dx = pointerX - ellipseX

      let dy = pointerY - ellipseY

      let lengthSquared = dx * dx + dy * dy

      // if new length is shortest, save this ellipse point
      if (lengthSquared < minLengthSquared) {
        minX = ellipseX

        minY = ellipseY

        minLengthSquared = lengthSquared
      }
    }

    if (dist <= 1 && this.hover === false) {
      let vector = { x: pointerX - center.x, y: pointerY - center.y }

      angle = Math.atan2(vector.y, vector.x)

      this.hover = true
    } else if (dist > 1 && this.hover === true) {
      let vector = { x: pointerX - center.x, y: pointerY - center.y }

      angle = Math.atan2(vector.y, vector.x)

      this.hover = false
    }

    if (typeof angle == "number") {
      let nearestPoint = null

      let distanceFromPoint = 100

      this.sprite.points.forEach(point => {
        let a = point.position.x - minX

        let b = point.position.y - minY

        let c = Math.sqrt(a * a + b * b)

        if (radiusX == radiusY) {
          if (Math.abs(angle - point.azimuth) < distanceFromPoint) {
            nearestPoint = point

            distanceFromPoint = Math.abs(angle - point.azimuth)
          }
        } else if (c < strength * 2) {
          nearestPoint = point
        }
      })

      if (nearestPoint) {
        let force = {
          x: this.oldMousePoint.x - pointerX,
          y: this.oldMousePoint.y - pointerY,
        }

        force = Math.sqrt(force.x * force.x + force.y * force.y) * 10

        if (force > strength) force = strength

        nearestPoint.acceleration = (force / 100) * (this.hover ? -1 : 1)
      }
    }

    this.oldMousePoint.x = pointerX

    this.oldMousePoint.y = pointerY
  }

  drawResults(mouseX, mouseY, ellipseX, ellipseY) {
    this.sprite.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height)
    this.sprite.ctx.beginPath()
    this.sprite.ctx.moveTo(mouseX, mouseY)
    this.sprite.ctx.lineTo(ellipseX, ellipseY)
    this.sprite.ctx.lineWidth = 1
    this.sprite.ctx.strokeStyle = "red"
    this.sprite.ctx.stroke()
  }

  resize() {
    let width = this.options.size.width

    let height = this.options.size.height

    let incr = this.options.size.widthIncr || 1

    let fixedHeight = this.options.size.fixedHeight

    let ratio = width / height

    let canvasWidth = window.innerWidth * incr

    let canvasHeight = fixedHeight ? height : canvasWidth / ratio

    let offset = (window.innerWidth - canvasWidth) / 2

    this.canvas.width = canvasWidth

    this.canvas.height = canvasHeight

    TweenMax.set(this.canvas, { x: offset })
  }
}
